


  
  

  var faSquareFull = {
    prefix: 'fas',
    iconName: 'square-full',
    icon: [
      512,
      512,
      [11035,11036,128997,128998,128999,129000,129001,129002,129003],
      'f45c',
      
      'M0 0H512V512H0V0z'
      
    ]
  };

  

  
  

  var faWandMagic = {
    prefix: 'fas',
    iconName: 'wand-magic',
    icon: [
      512,
      512,
      ["magic"],
      'f0d0',
      
      'M14.1 463.3c-18.7-18.7-18.7-49.1 0-67.9L395.4 14.1c18.7-18.7 49.1-18.7 67.9 0l34.6 34.6c18.7 18.7 18.7 49.1 0 67.9L116.5 497.9c-18.7 18.7-49.1 18.7-67.9 0L14.1 463.3zM347.6 187.6l105-105L429.4 59.3l-105 105 23.3 23.3z'
      
    ]
  };

  
    var faMagic = faWandMagic;
  

  
  

  var faRocket = {
    prefix: 'fas',
    iconName: 'rocket',
    icon: [
      512,
      512,
      [],
      'f135',
      
      'M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2v82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9V380.8c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z'
      
    ]
  };

  

  
  

  var faChevronDown = {
    prefix: 'fas',
    iconName: 'chevron-down',
    icon: [
      512,
      512,
      [],
      'f078',
      
      'M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z'
      
    ]
  };

  

  
  

  var faMagnifyingGlass = {
    prefix: 'fas',
    iconName: 'magnifying-glass',
    icon: [
      512,
      512,
      [128269,"search"],
      'f002',
      
      'M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z'
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faPlay = {
    prefix: 'fas',
    iconName: 'play',
    icon: [
      384,
      512,
      [9654],
      'f04b',
      
      'M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z'
      
    ]
  };

  

  
  

  var faArrowDown = {
    prefix: 'fas',
    iconName: 'arrow-down',
    icon: [
      384,
      512,
      [8595],
      'f063',
      
      'M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z'
      
    ]
  };

  

  
  

  var faEllipsis = {
    prefix: 'fas',
    iconName: 'ellipsis',
    icon: [
      448,
      512,
      ["ellipsis-h"],
      'f141',
      
      'M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z'
      
    ]
  };

  
    var faEllipsisH = faEllipsis;
  

  
  

  var faStop = {
    prefix: 'fas',
    iconName: 'stop',
    icon: [
      384,
      512,
      [9209],
      'f04d',
      
      'M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z'
      
    ]
  };

  

  
  

  var faEllipsisVertical = {
    prefix: 'fas',
    iconName: 'ellipsis-vertical',
    icon: [
      128,
      512,
      ["ellipsis-v"],
      'f142',
      
      'M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z'
      
    ]
  };

  
    var faEllipsisV = faEllipsisVertical;
  

  
  

  var faCaretDown = {
    prefix: 'fas',
    iconName: 'caret-down',
    icon: [
      320,
      512,
      [],
      'f0d7',
      
      'M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z'
      
    ]
  };

  

  
  

  var faQuoteRight = {
    prefix: 'fas',
    iconName: 'quote-right',
    icon: [
      448,
      512,
      [8221,"quote-right-alt"],
      'f10e',
      
      'M448 296c0 66.3-53.7 120-120 120h-8c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H320c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72zm-256 0c0 66.3-53.7 120-120 120H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h8c30.9 0 56-25.1 56-56v-8H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h64c35.3 0 64 28.7 64 64v32 32 72z'
      
    ]
  };

  
    var faQuoteRightAlt = faQuoteRight;
  

  
  

  var faSquareHeart = {
    prefix: 'fas',
    iconName: 'square-heart',
    icon: [
      448,
      512,
      [128159,"heart-square"],
      'f4c8',
      
      'M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM99.9 280.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L246.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L99.9 280.9z'
      
    ]
  };

  
    var faHeartSquare = faSquareHeart;
  

  
  

  var faSortUp = {
    prefix: 'fas',
    iconName: 'sort-up',
    icon: [
      320,
      512,
      ["sort-asc"],
      'f0de',
      
      'M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z'
      
    ]
  };

  
    var faSortAsc = faSortUp;
  

  
  

  var faCircle = {
    prefix: 'fas',
    iconName: 'circle',
    icon: [
      512,
      512,
      [9679,9898,9899,11044,61708,61915,128308,128309,128992,128993,128994,128995,128996],
      'f111',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faCirclePause = {
    prefix: 'fas',
    iconName: 'circle-pause',
    icon: [
      512,
      512,
      [62092,"pause-circle"],
      'f28b',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM224 192V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32zm128 0V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V192c0-17.7 14.3-32 32-32s32 14.3 32 32z'
      
    ]
  };

  
    var faPauseCircle = faCirclePause;
  

  
  

  var faListOl = {
    prefix: 'fas',
    iconName: 'list-ol',
    icon: [
      512,
      512,
      ["list-1-2","list-numeric"],
      'f0cb',
      
      'M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z'
      
    ]
  };

  
    var faList12 = faListOl;
  
    var faListNumeric = faListOl;
  

  
  

  var faSort = {
    prefix: 'fas',
    iconName: 'sort',
    icon: [
      320,
      512,
      ["unsorted"],
      'f0dc',
      
      'M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z'
      
    ]
  };

  
    var faUnsorted = faSort;
  

  
  

  var faItalic = {
    prefix: 'fas',
    iconName: 'italic',
    icon: [
      384,
      512,
      [],
      'f033',
      
      'M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z'
      
    ]
  };

  

  
  

  var faSquare = {
    prefix: 'fas',
    iconName: 'square',
    icon: [
      448,
      512,
      [9632,9723,9724,61590],
      'f0c8',
      
      'M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z'
      
    ]
  };

  

  
  

  var faPause = {
    prefix: 'fas',
    iconName: 'pause',
    icon: [
      320,
      512,
      [9208],
      'f04c',
      
      'M48 64C21.5 64 0 85.5 0 112V400c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H48zm192 0c-26.5 0-48 21.5-48 48V400c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48H240z'
      
    ]
  };

  

  
  

  var faCircleStop = {
    prefix: 'fas',
    iconName: 'circle-stop',
    icon: [
      512,
      512,
      [62094,"stop-circle"],
      'f28d',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 160H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z'
      
    ]
  };

  
    var faStopCircle = faCircleStop;
  

  
  

  var faCircleCheck = {
    prefix: 'fas',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533,"check-circle"],
      'f058',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z'
      
    ]
  };

  
    var faCheckCircle = faCircleCheck;
  

  
  

  var faCirclePlay = {
    prefix: 'fas',
    iconName: 'circle-play',
    icon: [
      512,
      512,
      [61469,"play-circle"],
      'f144',
      
      'M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c-7.6 4.2-12.3 12.3-12.3 20.9V344c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88c-7.4-4.5-16.7-4.7-24.3-.5z'
      
    ]
  };

  
    var faPlayCircle = faCirclePlay;
  

  
  

  var faCaretUp = {
    prefix: 'fas',
    iconName: 'caret-up',
    icon: [
      320,
      512,
      [],
      'f0d8',
      
      'M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z'
      
    ]
  };

  

  
  

  var faBold = {
    prefix: 'fas',
    iconName: 'bold',
    icon: [
      384,
      512,
      [],
      'f032',
      
      'M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z'
      
    ]
  };

  

  
  

  var faUnderline = {
    prefix: 'fas',
    iconName: 'underline',
    icon: [
      448,
      512,
      [],
      'f0cd',
      
      'M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z'
      
    ]
  };

  

  
  

  var faList = {
    prefix: 'fas',
    iconName: 'list',
    icon: [
      512,
      512,
      ["list-squares"],
      'f03a',
      
      'M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z'
      
    ]
  };

  
    var faListSquares = faList;
  

  
  

  var faAsterisk = {
    prefix: 'fas',
    iconName: 'asterisk',
    icon: [
      384,
      512,
      [10033,61545],
      '2a',
      
      'M192 32c17.7 0 32 14.3 32 32V199.5l111.5-66.9c15.2-9.1 34.8-4.2 43.9 11s4.2 34.8-11 43.9L254.2 256l114.3 68.6c15.2 9.1 20.1 28.7 11 43.9s-28.7 20.1-43.9 11L224 312.5V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V312.5L48.5 379.4c-15.2 9.1-34.8 4.2-43.9-11s-4.2-34.8 11-43.9L129.8 256 15.5 187.4c-15.2-9.1-20.1-28.7-11-43.9s28.7-20.1 43.9-11L160 199.5V64c0-17.7 14.3-32 32-32z'
      
    ]
  };

  

  
  

  var faStrikethrough = {
    prefix: 'fas',
    iconName: 'strikethrough',
    icon: [
      512,
      512,
      [],
      'f0cc',
      
      'M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z'
      
    ]
  };

  

  
  

  var faCircleHeart = {
    prefix: 'fas',
    iconName: 'circle-heart',
    icon: [
      512,
      512,
      ["heart-circle"],
      'f4c7',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM131.9 280.9c-29.4-29.8-29.4-78.2 0-108s77-29.8 106.4 0l17.7 18 17.7-18c29.4-29.8 77-29.8 106.4 0s29.4 78.2 0 108L278.5 384.1c-6.2 6.3-14.3 9.4-22.5 9.4s-16.3-3.1-22.5-9.4L131.9 280.9z'
      
    ]
  };

  
    var faHeartCircle = faCircleHeart;
  

  
  

  var faCircleMinus = {
    prefix: 'fas',
    iconName: 'circle-minus',
    icon: [
      512,
      512,
      ["minus-circle"],
      'f056',
      
      'M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z'
      
    ]
  };

  
    var faMinusCircle = faCircleMinus;
  

  
  

  var faSortDown = {
    prefix: 'fas',
    iconName: 'sort-down',
    icon: [
      320,
      512,
      ["sort-desc"],
      'f0dd',
      
      'M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z'
      
    ]
  };

  
    var faSortDesc = faSortDown;
  



export {

  faSquareFull,
  

  faWandMagic,
  
  faMagic,
  

  faRocket,
  

  faChevronDown,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faPlay,
  

  faArrowDown,
  

  faEllipsis,
  
  faEllipsisH,
  

  faStop,
  

  faEllipsisVertical,
  
  faEllipsisV,
  

  faCaretDown,
  

  faQuoteRight,
  
  faQuoteRightAlt,
  

  faSquareHeart,
  
  faHeartSquare,
  

  faSortUp,
  
  faSortAsc,
  

  faCircle,
  

  faCirclePause,
  
  faPauseCircle,
  

  faListOl,
  
  faList12,
  
  faListNumeric,
  

  faSort,
  
  faUnsorted,
  

  faItalic,
  

  faSquare,
  

  faPause,
  

  faCircleStop,
  
  faStopCircle,
  

  faCircleCheck,
  
  faCheckCircle,
  

  faCirclePlay,
  
  faPlayCircle,
  

  faCaretUp,
  

  faBold,
  

  faUnderline,
  

  faList,
  
  faListSquares,
  

  faAsterisk,
  

  faStrikethrough,
  

  faCircleHeart,
  
  faHeartCircle,
  

  faCircleMinus,
  
  faMinusCircle,
  

  faSortDown,
  
  faSortDesc,
  

};
